import React from 'react';
import icon1 from '../../assets/img/HireAdvantages/1.png';

const HireAdvantages = () => {
    const advantages = [
        {
            title: "Reduce Project Risks",
            desc: "Being our partner is synonymous with peace of mind. We come in with our own backup resources and an experienced Project Manager, thus you do not need to incur extra expenses of over-paying or under-utilizing personnel. Naturally, you also get rid of off-season management costs of the team."
        },
        {
            title: "Affordable Pricing",
            desc: "Our expertise in outsourcing will enable you to enjoy low hourly rates and at the same time enjoy high quality. We design our prices to suit your project, and we provide flexible models that are already able to save a lot of money."
        },
        {
            title: "Zero Recruitment Hassles",
            desc: "We simplify the recruitment process. Our team selects first-rate talent and offers them to you, which means that they can access any proficient expert without the conventional hiring hassles."
        },
        {
            title: "Maximum Project Efficiency",
            desc: "BIM professionals are on-site in different time locations. They even can support during weekends and holidays so that there is no problem in meeting the tight deadlines."
        },
        {
            title: "Transparent Project Management",
            desc: "A dedicated Project Manager will keep you informed about all the stages of the projects; he will work with your expert. There will be no communication barriers and transparency on all levels."
        },
        {
            title: "Flexible Time Zones and Availability",
            desc: "Time zone differences may be quite significant. Nevertheless, we have got a committed BIM personnel who may match your time schedule and competently manage their time in accordance with yours."
        }
    ];

    return (
        <section className="hire-advantages">
            <div className="advantages-container">
                <div className="advantages-header">
                    <h2 className="advantages-title">
                        <span className="text-primary">Advantages of Recruiting</span> Our Exclusive Resources.
                    </h2>
                    <p className="advantages-subtitle">
                        Our Scan to BIM service offers us an in-house service of trained BIM Modelers and Specialists. 
                        Our support is supported by the successful experience of international architectural projects, 
                        as well as the responsibility of the whole project, and the data protection standard.
                    </p>
                </div>

                <div className="advantages-grid">
                    {advantages.map((adv, index) => (
                        <div key={index} className="advantage-card">
                            <div className="advantage-icon">
                                <div className="bag-icon-bg">
                                    <img src={icon1.src || icon1} alt="Advantage" className="advantage-custom-icon" />
                                </div>
                            </div>
                            <h3 className="advantage-card-title">{adv.title}</h3>
                            <p className="advantage-card-desc">{adv.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HireAdvantages;
